var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    fill: "rgba(100,21,255,1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136,168v160c0,13.232,10.768,24,24,24h176c13.232,0,24-10.768,24-24V168c0-13.232-10.768-24-24-24H160 C146.768,144,136,154.768,136,168z M152,224h24v16h-24V224z M152,256h24v16h-24V256z M208,336h-16v-16h-16v16h-16 c-4.416,0-8-3.592-8-8v-40h24v16h32V336z M192,288v-80h112v80H192z M240,336h-16v-32h16V336z M272,336h-16v-32h16V336z M344,328 c0,4.408-3.584,8-8,8h-16v-16h-16v16h-16v-32h32v-16h24V328z M344,272h-24v-16h24V272z M344,240h-24v-16h24V240z M288,160h16v16 h16v-16h16c4.416,0,8,3.592,8,8v40h-24v-16h-32V160z M256,160h16v32h-16V160z M224,160h16v32h-16V160z M192,176v-16h16v32h-32v16 h-24v-40c0-4.408,3.584-8,8-8h16v16H192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,272h80v-48h-80V272z M224,240h48v16h-48V240z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 368,
    width: 16,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 480,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 368,
    width: 16,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 480,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192,432 80,432 80,448 208,448 208,368 192,368"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 432,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176,368 160,368 160,400 32,400 32,416 176,416"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 400,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304,368 288,368 288,448 416,448 416,432 304,432"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 432,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336,368 320,368 320,416 464,416 464,400 336,400"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 400,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 32,
    width: 16,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 32,
    width: 16,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304,64 416,64 416,48 288,48 288,128 304,128"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 48,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320,128 336,128 336,96 464,96 464,80 320,80"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 80,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192,128 208,128 208,48 80,48 80,64 192,64"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160,128 176,128 176,80 32,80 32,96 160,96"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 16,
    height: 16
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/electronics.d5a6be54e4ebbdda0db926e0698f42dc.svg";
export { ForwardRef as ReactComponent };